/** @module Auth0CdnResourceResolver */

/* @@AUTH0-LOADER-CDN@@
remote:'https://cdn.shipstation.com/auth0/shipstation-stage'
local:'https://localcdn.shipstation.com'
*/
const AUTH0_SCRIPTS_URL = 'https://cdn.shipstation.com/auth0/shipstation-stage';

/* @@AUTH0-LOADER-CDN@@
remote:'https://cdn.shipstation.com/auth0/shipstation-stage/public/images'
local:'https://localcdn.shipstation.com/public/images'
*/
const AUTH0_IMAGES_URL = 'https://cdn.shipstation.com/auth0/shipstation-stage/public/images';

/* @@AUTH0-LOADER-CDN@@
remote:'https://cdn.shipstation.com/auth0/shipstation-stage/public/styles'
local:'https://localcdn.shipstation.com/public/styles'
*/
const AUTH0_STYLES_URL = 'https://cdn.shipstation.com/auth0/shipstation-stage/public/styles';

/* @@AUTH0-LOADER-CDN@@
remote:'https://cdn.shipstation.com/auth0/shipstation-stage/public/scripts'
local:'https://localcdn.shipstation.com/public/scripts'
*/
const AUTH0_EXTERNAL_SCRIPTS_URL = 'https://cdn.shipstation.com/auth0/shipstation-stage/public/scripts';

class Auth0CdnResourceResolver {
  static get AUTH0_SCRIPTS_URL() {
    return AUTH0_SCRIPTS_URL;
  }

  static get AUTH0_EXTERNAL_SCRIPTS_URL() {
    return AUTH0_EXTERNAL_SCRIPTS_URL;
  }

  static get AUTH0_IMAGES_URL() {
    return AUTH0_IMAGES_URL;
  }

  static get AUTH0_STYLES_URL() {
    return AUTH0_STYLES_URL;
  }

  static get AUTH0_BRAND_IMAGES_URL() {
    return `${AUTH0_IMAGES_URL}/branding`;
  }

  static get AUTH0_LOGO_URL() {
    return `${this.AUTH0_BRAND_IMAGES_URL}/shipstation-logo.png`;
  }

  static get AUTH0_LOGO_ICON_URL() {
    return `${this.AUTH0_BRAND_IMAGES_URL}/shipstation-icon.png`;
  }

  static get AUTH0_WAIT_SPINNER_URL() {
    return `${this.AUTH0_BRAND_IMAGES_URL}/shipstation-icon.png`;
  }

  static get AUTH0_CONNECT_LOGO_URL() {
    return `${this.AUTH0_BRAND_IMAGES_URL}/shipstation-connect-logo.svg`;
  }

  static get AUTH0_FAVICON_16_URL() {
    return `${this.AUTH0_BRAND_IMAGES_URL}/favicon/ss-favicon-16x16.png`;
  }

  static get AUTH0_FAVICON_32_URL() {
    return `${this.AUTH0_BRAND_IMAGES_URL}/favicon/ss-favicon-32x32.png`;
  }

  static get AUTH0_APPLE_TOUCH_ICON_URL() {
    return `${this.AUTH0_BRAND_IMAGES_URL}/favicon/ss-apple-touch-icon.png`;
  }

  static get AUTH0_MASK_ICON_URL() {
    return `${this.AUTH0_BRAND_IMAGES_URL}/favicon/ss-safari-pinned-tab.svg`;
  }

  static get AUTH0_NOTIFICATION_INFO_ICON_URL() {
    return `${this.AUTH0_IMAGES_URL}/circle-info.svg`;
  }

  static get AUTH0_NOTIFICATION_ERROR_ICON_URL() {
    return `${this.AUTH0_IMAGES_URL}/error.svg`;
  }

  static get AUTH0_SCRIPT_URL_LAUNCHDARKLY() {
    return `${this.AUTH0_EXTERNAL_SCRIPTS_URL}/ldclient.min.js`;
  }

  static get AUTH0_SCRIPT_URL_MARKDOWN_IT() {
    return `${this.AUTH0_EXTERNAL_SCRIPTS_URL}/markdown-it.min.js`;
  }
}

export default Auth0CdnResourceResolver;
